import styles from './PrimaryCTA.module.css';

const PrimaryCTA = props => {
	return (
		<button className={`btn btn-primary ${styles.PrimaryCTA}`} 
			onClick={props.clickHandler}
		>
			{props.children}
		</button>
	)
}

export default PrimaryCTA;
